/* 🤖 this file was generated by svg-to-ts */
export const matIconFormatAlignJustify: {
  name: 'format-align-justify';
  data: string;
} = {
  name: 'format-align-justify',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z"/></svg>`
};
